import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ClienteAutoAvaliar } from "./../../models/ClienteAutoAvaliar";
import { generateIdempotencyKey } from "src/app/utils/idempotency-key.util";

@Injectable({
  providedIn: "root",
})
export class LaudoUnionService {

  emitirSelect = new EventEmitter();
  tipoConsultas: any;

  constructor(private http: HttpClient) {}

  private buildIdempotencyHeaders(idempotencyKey?: string) {
    return {
      headers: {
        "Idempotency-Key": idempotencyKey || generateIdempotencyKey("laudo"),
      },
    };
  }

  atualizaIntegracao(token, idintegracao) {
    return this.http
      .post(environment.wsUrl + "laudo/atualizaIntegracao/", {
        token,
        idintegracao,
      })
      .toPromise();
  }
  getApontamentosLaudo(token) {
    return this.http
      .get(environment.wsUrl + "laudo/getParecerSistema/" + token)
      .toPromise();
  }

  finalizarLaudo(token, parecerNivel, parecerObs, transmitirLaudo, utl) {
    return this.http
      .post(environment.wsUrl + "laudo/finalizarLaudo/", {
        token,
        parecerNivel,
        parecerObs,
        transmitirLaudo,
        utl,
      })
      .toPromise();
  }

  /* Configuração de >tipo< de laudo */
  getConfigTipoLaudo(id) {
    return this.http
      .get(environment.wsUrl + "laudo/getNovaConfigLaudo/" + id)
      .toPromise();
  }

  /* Configuração de laudo */
   getConfigLaudo(uuid) {
    return this.http
      .get(environment.wsUrl + "laudo/getConfigLaudo/" + uuid)
      .toPromise();
  }

  getListaLaudos(params) {
    let data = { ...params };
    data.sorting = {};

    for (const i in params.sorting) {
      if (params.sorting[i] != "") {
        data.sorting[i] = params.sorting[i];
      }
    }
    return this.http
      .post<{ lista: []; total: number }>(
        environment.wsUrl + "laudo/getListaLaudo",
        data
      )
      .toPromise();
  }

  downloadExcel(params, ignore = ["content-type"]) {
    let data = { ...params };
    data.sorting = {};

    for (const i in params.sorting) {
      if (params.sorting[i] != "") {
        data.sorting[i] = params.sorting[i];
      }
    }

    return this.http
      .post(environment.wsUrl + "laudo/getListaLaudoXls", data, {
        params: { ignore: ignore },
        responseType: "blob",
      })
      .toPromise();
  }

  downloadExcelAuditoria(params) {
    let data = { ...params };
    data.sorting = {};

    for (const i in params.sorting) {
      if (params.sorting[i] != "") {
        data.sorting[i] = params.sorting[i];
      }
    }

    return this.http
      .post(environment.wsUrl + "auditoria/getListaLaudoXls", data, {
        responseType: "blob",
      })
      .toPromise();
  }

  getListaLaudosAgendados(params, ignore = ["loading"]) {
    let data = { ...params };
    data.sorting = {};

    for (const i in params.sorting) {
      if (params.sorting[i] != "") {
        data.sorting[i] = params.sorting[i];
      }
    }
    return this.http
      .post<{ lista: []; total: number }>(
        environment.wsUrl + "laudo/getListaLaudoAgendado",
        data,
        { params: { ignore: ignore } }
      )
      .toPromise();
  }

  getListaTipoLaudo() {
    return this.http
      .get<any[]>(environment.wsUrl + "laudo/listaTipoLaudo")
      .toPromise();
  }

  getListaClientes() {
    return this.http
      .get<any[]>(environment.wsUrl + "unidade/listaClienteCombo")
      .toPromise();
  }

  getListaClienteUnidade() {
    return this.http
      .get<any[]>(environment.wsUrl + "unidade/getUnidadesAtendidas")
      .toPromise();
  }

  getListaClienteUnidadeConfig() {
    return this.http
      .get<any[]>(environment.wsUrl + "unidade/getUnidadesAtendidasConfig")
      .toPromise();
  }

  getListaUnidades() {
    return this.http
      .get<any[]>(environment.wsUrl + "unidade/listaUnidadesCombo")
      .toPromise();
  }

  excluirConfigLaudo(uuid, justificativa) {
    return this.http
      .post(
        environment.wsUrl + "laudo/deletarConfigLaudo",
        { uuid: uuid },
        { headers: { justificativa: justificativa } }
      )
      .toPromise();
  }

  salvarConfigLaudo(config) {
    return this.http
      .post(environment.wsUrl + "laudo/salvarPermissoesLaudo", config)
      .toPromise();
  }

  salvarNovoVistoriador(json){
    return this.http.post(environment.wsUrl + "laudo/salvarNovoVistoriador", json).toPromise();
  }

  atualizarDataAgendamento(json){
    return this.http.post(environment.wsUrl + "laudo/atualizarDataAgendamento", json).toPromise();
  }

  editarConfigLaudo(uuid, config) {
    return this.http
      .post(environment.wsUrl + "laudo/atualizarPermissoesLaudo", {
        uuidConfigLaudo: uuid,
        listasPermissoes: config,
      })
      .toPromise();
  }

  getListaConfigLaudo(search: {
    sorting: { nome: string; descricao: string };
    per_page: number;
    page: number;
    data?: Date;
  }) {
    return this.http
      .post<{ lista: []; total: number }>(
        environment.wsUrl + "laudo/getListaConfigTipoLaudo",
        search
      )
      .toPromise();
  }

  getListaCopyConfigLaudo(id) {
    return this.http
      .get<{ lista: []; total: number }>(
        environment.wsUrl + "laudo/getListaConfigTipoLaudo/" + id
      )
      .toPromise();
  }

  getVeiculoPlacaChassi(id) {
    return this.http
      .get<any[]>(environment.wsUrl + "laudo/preencheVeiculo/" + id)
      .toPromise();
  }

  getListaTipoLaudoCliente(id) {
    return this.http
      .get<any[]>(environment.wsUrl + "laudo/getListaTipoLaudo/" + id)
      .toPromise();
  }

  getListaVistoriador(id) {
      return this.http
        .get<any[]>(environment.wsUrl + "laudo/getListaVistoriador/" + id)
        .toPromise();
  }

  salvarAgendamento(json) {
    return this.http
      .post<any>(environment.wsUrl + "laudo/agendarLaudo", json)
      .toPromise();
  }

  salvarAgendamentoLote(listaAgendamentosJson) {
    return this.http
      .post<any>(environment.wsUrl + "laudo/agendarLaudoLote", listaAgendamentosJson)
      .toPromise();
  }

  cancelarAgendamento(laudoId, placa){
    return this.http
      .post<any>(environment.wsUrl + "laudo/cancelarAgendamento", {laudoId: laudoId, placa: placa})
      .toPromise();
  }

  getUnidadesAtendidas() {
    type UnidadesAtendidasLaudo = {
      documento: any;
      id: any;
      idPontoAtendimento: any;
      nomefantasia: any;
    };

    return this.http
      .get<[UnidadesAtendidasLaudo]>(
        environment.wsUrl + "unidade/getUnidadesAtendidas"
      )
      .toPromise();
  }

  getLaudo(token) {
    return this.http
      .get<any>(environment.wsUrl + "laudo/getLaudoNovo/" + token)
      .toPromise();
  }

  getRelatorioLaudo(token) {
    return this.http
      .get<any>(environment.wsUrl + "laudo/relatorio/" + token)
      .toPromise();
  }

  novoLaudo(dadosLaudo, idConsulta) {
    let data = { dadosLaudo: dadosLaudo, idConsulta: idConsulta };
    return this.http
      .post(environment.wsUrl + "laudo/novoLaudo/", data)
      .toPromise();
  }

  realizarConsultaLaudo(token, ip, idempotencyKey?: string) {
    return this.http
      .get<any>(
        environment.wsUrl + "laudo/consultar/" + token + "/" + ip,
        this.buildIdempotencyHeaders(idempotencyKey)
      )
      .toPromise();
  }

  salvarFormularioLaudo(formValues, token) {
    return this.http
      .post(environment.wsUrl + "laudo/salvarLaudoNovo/", {
        laudo: formValues,
        token: token,
      })
      .toPromise();
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     let responseValues = {
    //       ...formValues,
    //       elementName1: 'value 1',
    //       elementName2: '',
    //       elementName3: 'value 3',
    //     };
    //     resolve(responseValues)
    //   }, 1000);
    // })
  }

  downloadPdf(token) {
    return this.http
      .post(
        environment.wsUrl + "laudo/getLaudoPdf/",
        { tokenLaudo: token },
        { responseType: "blob" }
      )
      .toPromise();
    // return this.http.post( environment.wsUrl + 'laudo/getLaudoPdf/', token).toPromise();
  }

  getPdfCompactado(token) {
    return this.http
      .post(
        environment.wsUrl + "laudo/getPdfCompactado/",
        { tokenLaudo: token },
        { responseType: "blob" }
      )
      .toPromise();
  }

  downloadFotos(token) {
    return this.http
      .post(
        environment.wsUrl + "laudo/getDownloadFotos/",
        { tokenLaudo: token },
        { responseType: "blob" }
      )
      .toPromise();
  }

  updateInput(name: string, value: string, token: string, file: Blob = null) {
    const form = new FormData();
    form.append("name", name);
    form.append("value", value);
    form.append("token", token);
    form.append("file", file);
    return this.http
      .post<{ value: string }>(environment.wsUrl + "laudo/updateInput/", form, {
        params: { ignore: ["content-type", "loading"] },
      })
      .toPromise();
  }

  updateImageInput(name, file, token) {
    return this.updateInput(name, "", token, file);
  }

  change(v) {
    this.emitirSelect.emit(v);
  }

  getTipoConsultas(consultas, response) {
    if (response === "push") {
      this.tipoConsultas = consultas;
    }
    if (response === "get") {
      return this.tipoConsultas;
    }
  }

  getUnidadesMultiClientAutoAvaliar(token: string, uf: string) {
    if (!uf) {
      uf = "AC";
    }

    return this.http
      .get<[ClienteAutoAvaliar]>(
        environment.wsUrl +
          "laudo/getUnidadesMultiClientAutoAvaliar/" +
          token +
          "/" +
          uf
      )
      .toPromise();
  }

  existeCacheConsultaVeiculo(placa: string, token: string) {
    return this.http
      .get<any>(
        environment.wsUrl + "laudo/resgateParaLaudo/" + placa + "/" + token
      )
      .toPromise();
  }

  utilizarConsultaCache(idConsultaVeiculo: any, token: any) {
    return this.http
      .put<any>(
        environment.wsUrl +
          "laudo/inserirConsultaLaudo/" +
          idConsultaVeiculo +
          "/" +
          token,
        null
      )
      .toPromise();
  }

  inserirConsultaPeloIdResgate(idConsultaVeiculo: number, tokenLaudo: string) {
    return this.http
      .get<any>(
        `${environment.wsUrl}laudo/inserirConsultaPeloIdResgate/${idConsultaVeiculo}/${tokenLaudo}`
      )
      .toPromise();
  }

  getRelatorioPdf(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }
}
